module.exports = {"casino":{"nouvelle_demande":"Nouvelle demande","continuer_la_demande":"Continuer la demande","mon_compte":"Mon compte","se_connecter":"Se connecter","s_inscrire":"S'inscrire","accueil":"Accueil","mes_produits":"Mes produits","mes_dossiers":"Mes dossiers","mes_demandes":"Mes demandes","notifications":"Notifications","parametres":"Paramètres","deconnexion":"Déconnexion"}}


//////////////////
// WEBPACK FOOTER
// ./src/companies/casino/lang/fr/template/menu.lang.json
// module id = MSdH
// module chunks = 1